import { render } from "./recevez-vue.vue?vue&type=template&id=3ab3cc47&scoped=true"
import script from "./recevez-vue.vue?vue&type=script&lang=js"
export * from "./recevez-vue.vue?vue&type=script&lang=js"

import "./recevez-vue.vue?vue&type=style&index=0&id=3ab3cc47&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab3cc47"]])

export default __exports__